import { I18n } from 'src/translations/i18n';
export const SELECT_ELEMENT_HEIGHT = 40;
export const SEARCH_INPUT_ID = 'search-input';
export function toDropDownSelectorOptions(options, labelKey = 'Name', valueKey = 'Id', noTranslate = false, valueToString = false) {
    return options.map((opt) => ({
        label: noTranslate ? opt[labelKey] : I18n.t(opt[labelKey]),
        value: valueToString ? String(opt[valueKey]) : opt[valueKey]
    }));
}
export const optionsMapToDropDownSelectorOptions = (map, noTranslate = false) => {
    return Object.entries(map).map(([label, value]) => ({
        label: noTranslate ? label : I18n.t(label),
        value
    }));
};
export function getFlatOptionsList(options, nestingLevel = 0) {
    return options.reduce((acc, option) => {
        acc.push({ ...option, nestingLevel });
        if (option.children) {
            acc.push(...getFlatOptionsList(option.children, nestingLevel + 1));
        }
        return acc;
    }, []);
}
export function getOptionById(optionsList, optionId) {
    let res = null;
    optionsList.some((option) => {
        if (option.value === optionId) {
            res = option;
            return true;
        }
        else if (option.children && option.children.length) {
            const childOption = getOptionById(option.children, optionId);
            if (childOption) {
                res = childOption;
                return true;
            }
        }
        return false;
    });
    return res;
}
